import * as Yup from 'yup';

const ReviewInvoiceSearchParams = Yup.object({
  buyerOrgIds: Yup.string().optional(),
});

export default ReviewInvoiceSearchParams;
